import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const EmailTranscriptActions = createActionGroup({
  source: 'EmailTranscript',
  events: {
    'Request Transcript': props<{ email: string }>(),
    'Set Submitted': emptyProps(),
    'Set Failed': props<{ error: HttpErrorResponse }>(),
  },
});
